<template lang="pug">
   v-card
      v-toolbar(dark dense color="red" class="navFixed")
        v-toolbar-title IM Preview 
        v-spacer
        v-toolbar-title(v-if="activeStatus == 7") Approved on {{getTanggal(imItems.imDate)}}
        v-toolbar-title(v-if="activeStatus == 8") Rejected on {{getTanggal(imItems.imDate)}}
        v-toolbar-items
          v-btn(v-if="activeStatus == 9 && !tembusan.includes(viewer._id)" flat @click="forwardDialog = true")
            v-icon forward
            | &nbsp; Forward
          v-dialog(v-model="forwardDialog" persistent max-width="500px")
            v-card()
              v-card-title(class="headline grey lighten-2" v-if="imItems.imType == 10") Forex Forward
              v-card-title(class="headline grey lighten-2" v-else) IM Forward
              v-card-text
                v-layout(wrap)
                  v-flex(xs12 v-if="approval == 3" style="color:#ff2c03;") User tujuan forward
                  v-flex( xs12)
                    v-autocomplete(
                      v-model="userForward"
                      label="Select User"
                      :items="users"
                      color="blue-grey lighten-2"
                      item-text="name"
                      item-value="data"
                      return-object
                      chips
                      clearable
                      solo
                    )
                      template(v-slot:selection="data")
                        v-chip(:input-value="data.selected" color="blue-grey" class="white--text" v-on="on") {{data.item.name ? data.item.name : data.item.fullname}}
                      template(v-slot:item="data")
                        template
                          v-list-tile-content
                            v-list-tile-title(v-html="data.item.name ? data.item.name : data.item.fullname")
                            v-list-tile-sub-title(v-html="data.item.title ? data.item.title : data.item.title")
                  v-flex(xs12)
                    v-textarea(
                      v-model="forwardNote"
                      box
                      label="Comment (Optional)"
                      auto-grow
                      value=""
                    )
              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat @click.native="forwardDialog = false") Close
                div(class="text-xs-center")
                  v-btn(:disabled="forwardDialog2" :loading="forwardDialog2" color="blue darken-1" flat @click="forwardDialog2 = true") Submit
                  v-dialog(
                    v-model="forwardDialog2"
                    hide-overlay
                    persistent
                    width="300")
                    v-card(color="primary" dark)
                      v-card-text Processing. Please wait!
                        v-progress-linear(indeterminate color="white" class="mb-0")

          v-btn(v-if="viewer.forward == 1" flat @click="replyDialog = true")
            v-icon reply
            | &nbsp; Reply
          v-dialog(v-model="replyDialog" persistent max-width="500px")
            v-card()
              v-card-title(class="headline grey lighten-2" v-if="imItems.imType == 10") Forex Reply
              v-card-title(class="headline grey lighten-2" v-else) IM Reply
              v-card-text
                v-layout(wrap)
                  v-flex(xs12)
                    v-textarea(
                      v-model="replyNote"
                      box
                      label="Comment (Optional)"
                      auto-grow
                      value=""
                    )

              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat @click.native="replyDialog = false") Close
                div(class="text-xs-center")
                  v-btn(:disabled="replyDialog2" :loading="replyDialog2" color="blue darken-1" flat @click="replyDialog2 = true") Submit
                  v-dialog(
                    v-model="replyDialog2"
                    hide-overlay
                    persistent
                    width="300")
                    v-card(color="primary" dark)
                      v-card-text Processing. Please wait!
                        v-progress-linear(indeterminate color="white" class="mb-0")

          v-btn(v-if="(activeStatus == 9 || activeStatus == 3) && !tembusan.includes(viewer._id)" flat :to="{ path: '/login', query: {r: getEditUrl(imItems.imType, imItems._id), workflow: imItems.imWorkflow}}" replace)
            v-icon edit
            | &nbsp; Edit

          //- hide edit button
          //- v-btn(v-if="(activeStatus == 9 || activeStatus == 3) && !tembusan.includes(viewer._id) && imItems.imType != 9 && imItems.imType != 10" flat :to="{ path: '/login', query: {r: getEditUrl(imItems.imType, imItems._id)}}" replace)
          //-   v-icon edit
          //-   | &nbsp; Edit
          v-btn(v-if="imItems.imFileLampiran" flat @click="download(imItems.imFileLampiran)" title="Download Lampiran")
            v-icon cloud_download
            | &nbsp; Lampiran
          v-btn(v-if="(activeStatus == 9 || activeStatus == 3) && !tembusan.includes(viewer._id)" flat title='Approval' @click="approvalDialog = true" color="black" class="blink") 
            v-icon(title="Approval") assignment_turned_in
            | &nbsp;Approval
          v-dialog(v-model="approvalDialog" persistent max-width="500px")
            v-card()
              v-card-title(class="headline grey lighten-2") Approval Form
              v-card-text
                v-layout(wrap)
                  v-flex(xs12)
                    v-radio-group(v-model="approval" row)
                      v-radio(v-if="imItems.imStatus != 3" label="Approve" color="success" value="7")
                      v-radio(v-if="imItems.imStatus != 3" label="Reject" color="red" value="8")
                      v-radio(label="Need Review" color="yellow darken-4" value="3")

                    //- hide need review
                    //- v-radio(v-if="imItems.imType != 9 && imItems.imType != 10" label="Need Review" color="yellow darken-4" value="3")
                    span(v-if="approval == 3" style="color:#ff2c03;") Approval akan dimulai lagi dari approver yang dipilih!
                  v-flex(v-if="approval == 3" xs12)
                    v-select(
                      v-model="select"
                      :hint="jabatan"
                      :items="reviewer"
                      item-text="fullname"
                      item-value="data"
                      label="Select"
                      persistent-hint
                      return-object
                      single-line
                      dense)
                  v-flex(xs12)
                    v-textarea(
                      v-model="comment"
                      box
                      label="Comment (Optional)"
                      auto-grow
                      value=""
                    )
              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat @click.native="approvalDialog = false") Close
                div(class="text-xs-center")
                  v-btn(:disabled="!select.hasOwnProperty('id') && approval == 3" :loading="approvalDialog2" color="blue darken-1" flat @click="approvalDialog2 = true") Submit
                  v-dialog(
                    v-model="approvalDialog2"
                    hide-overlay
                    persistent
                    width="300")
                    v-card(color="primary" dark)
                      v-card-text Processing. Please wait!
                        v-progress-linear(indeterminate color="white" class="mb-0")
          v-btn(flat @click='printIM(imItems._id)')
            v-icon print
            | &nbsp; Print 
          v-btn(dark flat onclick="javascript:window.close();") 
            v-icon(title="Close") cancel
            | &nbsp;Close
      v-list(three-line subheader class="print-bg padTop60")
        div(:id="imItems._id")
          .page(size="Auto")
            table(id="header-view" class="view-width print-header")
              tbody
                tr
                  td(v-if="imItems.imType != 9 && imItems.imType != 10" class="logo-cell") 
                    //- img(v-if="imItems.imGroup === 'gems'" src="../assets/smm-logo.png" class="width-300px")
                    //- img(v-if="imItems.imGroup === 'bcg'" src="../assets/bc-logo-188.png" class="width-300px")
                    //- img(v-if="imItems.imGroup == 'nongroup' && imItems.imCompany != 'Others' " :src="ngCompany" class="width-300px")
                    img(v-if="(imItems.imCompany != 'Others' && imItems.imCompany == 'Sun Energy Group')" :src="imgSrc" class="width-150px")
                    img(v-else-if="imItems.imCompany != 'Others' " :src="imgSrc" class="width-300px")
                  td(v-else class="logo-cell") 
                    img(v-if="imItems.imGroup === 'bc'" src="../assets/bc-logo-188.png" class="width-300px")
                    img(v-if="imItems.imGroup === 'bce'" src="../assets/bce-logo-188.png" class="width-300px")
                    img(v-if="imItems.imGroup === 'mtl'" src="../assets/mtl-logo-188.jpg" class="width-300px")
            div(class="view-width" style="font-size:14px;")
              h2(style="text-align:center;padding:5px;" v-if="imItems.imType != 10") INTERNAL MEMO 
              h2(style="text-align:center;padding:5px;" v-if="imItems.imType == 10") FOREIGN EXCHANGE 
              hr(v-if="imItems.imType < 6 || imItems.imType == 9 || imItems.imType == 10 || imItems.imType == 11" style="border-style: inset;border-width: 2px;")
              table(v-if="imItems.imType == 6" class="view-width" style="margin-top:10px;")
                tbody
                  tr
                    td(width="100") No.
                    td(width="10") :
                    td {{ imItems.imNo }}
                  tr
                    td Kepada
                    td :
                    td {{ imItems.imKepada }}
                  tr
                    td Dari
                    td :
                    td {{ imItems.imDari }}
                  tr
                    td Tanggal
                    td :
                    td {{ getTanggal(imItems.imDate) }}
                  tr
                    td Perihal
                    td :
                    td 
                      strong {{ imItems.imPerihal }}
                  tr
                    td CC
                    td :
                    td
                      //- span(v-for="item in imItems.imCC" class="pr-2") {{item.name}},
                      span(v-for="(item, index) in imItems.imCC" class="pr-2" v-if="index !== imItems.imCC.length-1") {{item.name}},
                      span(v-else) {{item.name}} 
              table(v-else class="view-width" style="margin-top:10px;")
                tbody
                  tr
                    td(style="font-size:15px;width:40%;") 
                      strong KEPADA / TO : BAPAK/IBU
                    td(style="font-size:15px;")
                      strong DARI / FROM :
                  tr
                    td(valign="top")
                      ul(v-if="imItems.imType == 11 && imItems.imUseAlias")
                        li(v-for="(requestor, i) in imItems.imWorkflow.slice().reverse()" :key="i" style="font-size:15px;" v-if="requestor.status != 5")
                          span(v-if="requestor.hasOwnProperty('aliasname') && requestor.aliasname") {{ requestor.aliasname }}
                          span(v-else-if="!requestor.hasOwnProperty('aliasname') && requestor.fullname") {{ requestor.fullname }}
                          span(v-else) {{ requestor.name ? requestor.name : requestor.fullname }}
                      ul(v-else)
                        li(v-for="(requestor, i) in imItems.imWorkflow.slice().reverse()" :key="i" style="font-size:15px;" v-if="requestor.status != 5")
                          span(v-if="requestor.fullname") {{ requestor.fullname }}
                          span(v-else) {{ requestor.name }}
                    td(valign="top")
                      ul(style="list-style-type: none; padding:0;")
                        li(style="font-size:15px;border-bottom:1px solid grey;") {{ imItems.imUser.fullname }}
                        li(style="font-size:15px;border-bottom:1px solid grey;")  
                          strong NOMOR / NUMBER
                          br
                          | {{ imItems.imNo }}
                        li(style="font-size:15px;border-bottom:1px solid grey;")  
                          strong TANGGAL / DATE
                          br
                          | {{ imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                        li(style="font-size:15px;border-bottom:1px solid grey;")  
                          strong PERIHAL / ISSUE
                          br
                          | {{ imItems.imPerihal }}
              table(v-if="imItems.imType < 6 || imItems.imType == 9 || imItems.imType == 10 || imItems.imType == 11" class="view-width" style="margin-top:5px;")
                tbody
              //-     tr
              //-       td(style="font-size:15px;" v-if="imItems.imType != 10 && imItems.imType != 11")
              //-         strong TIPE IM :
              //-         // | &nbsp;{{ (imItems.imType < 5) ? i18n.imType[imItems.imType] : 'General' }}{{ imItems.imType == 3 ? ` (${imItems.imVendor.name}${imItems.imVendor.appointed > 0 ? ' : sudah pernah ditunjuk '+imItems.imVendor.appointed+' kali' : '' })` : '' }}
              //-         | &nbsp; {{ imItems.imType < 5 ? i18n.imType[imItems.imType] : imItems.imType == 9 ? 'Percepatan Pembayaran' : 'General' }}{{ imItems.imType == 3 ? ` (${imItems.imVendor.name}${imItems.imVendor.appointed > 0 ? ' : sudah pernah ditunjuk '+imItems.imVendor.appointed+' kali' : '' })` : '' }}
              //-     tr(v-if="imItems.imType == 3")
              //-       td(style="font-size:15px;") 
              //-         strong ALASAN :
              //-         | &nbsp;{{ imItems.imAlasan }}
              //-     tr(v-if="imItems.imType != 10")
              //-       td(v-if="imItems.imType == 11 && imItems.imUseAlias" style="font-size:15px;") 
              //-         strong TEMBUSAN / CC : 
              //-         span(v-for="(item, index) in imItems.imCC" class="pr-2" v-if="index !== imItems.imCC.length-1") {{(item.aliasname != null && item.aliasname != '' && item.aliasname != ' ') ? item.aliasname : item.name}},
              //-         span(v-else) {{(item.aliasname != null && item.aliasname != '' && item.aliasname != ' ') ? item.aliasname : item.name}}
              //-       td(v-else style="font-size:15px;") 
              //-         strong TEMBUSAN / CC : 
              //-         span(v-for="(item, index) in imItems.imCC" class="pr-2" v-if="index !== imItems.imCC.length-1") {{item.name}},
              //-         span(v-else) {{item.name}} 
              //- hr(v-if="imItems.imType < 6 || imItems.imType == 11" style="border-style: inset;border-width: 2px;margin-top:10px;")
              //- div(v-if="imItems.imType < 6 || imItems.imType == 11" style="margin-bottom:1px;")
              //-   label(class="containerLbl") URGENT
              //-     input(v-if="imItems.imPrioritas == 1" type="checkbox" checked="checked" disabled)
              //-     input(v-else type="checkbox" disabled)
              //-     span(class="checkmark")
              //-   label(class="containerLbl") FOR REVIEW
              //-     input(v-if="imItems.imPrioritas == 2" type="checkbox" checked="checked" disabled)
              //-     input(v-else type="checkbox" disabled)
              //-     span(class="checkmark")
              //-   label(class="containerLbl") FOR COMMENT
              //-     input(v-if="imItems.imPrioritas == 3" type="checkbox" checked="checked" disabled)
              //-     input(v-else type="checkbox" disabled)
              //-     span(class="checkmark")
              //-   label(class="containerLbl") PLEASE REPLY
              //-     input(v-if="imItems.imPrioritas == 4" type="checkbox" checked="checked" disabled)
              //-     input(v-else type="checkbox" disabled)
              //-     span(class="checkmark")
              //-   label(class="containerLbl") PLEASE RECYCLE
              //-     input(v-if="imItems.imPrioritas == 5" type="checkbox" checked="checked" disabled)
              //-     input(v-else type="checkbox" disabled)
              //-     span(class="checkmark")
              //- hr(style="border-style: inset;border-width: 2px;")
              div(v-if="imItems.imType == 10" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") Description
                div(v-html="imItems.imDescription" class="ck-content")
              div(v-if="imItems.imType < 6 || imItems.imType == 9 || imItems.imType == 11" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") TUJUAN
                div(v-html="imItems.imTujuan" class="ck-content")
              div(v-if="imItems.imType < 6 || imItems.imType == 9 || imItems.imType == 11" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") LATAR BELAKANG
                div(v-html="imItems.imLatarBelakang" class="ck-content")
              div(v-if="imItems.imType < 6 || imItems.imType == 11" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") MENGUSULKAN
                div(v-html="imItems.imUsulan" class="ck-content")
              div(v-if="imItems.imType == 9" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") REKOMENDASI
                div(v-html="imItems.imUsulan" class="ck-content")
              div(v-if="imItems.imType != 6 && imItems.imType != 5 && imItems.imType != 9 && imItems.imType != 10 && imItems.imType != 11" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") NILAI PENGAJUAN PROJECT BUDGET
                div(v-html="getFormatCurrency(imItems.imValue)")
              div(v-if="imItems.imType < 6 || imItems.imType == 11" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") TARGET DELIVERY DATE
                div(v-html="getTanggal(imItems.imTargetDate)")
              div(v-if="imItems.imType == 9" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") TARGET PEMBAYARAN
                div(v-html="getTanggal(imItems.imTargetDate)")
              div(v-if="imItems.imType == 9" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") NOMOR LIV
                //- div(v-html="imItems.imLiv") 
                span(v-if="i !== imItems.imLiv.length-1" v-for="(item, i) in imItems.imLiv" :key="i") {{item}}, 
                span(v-else) {{item}}
              div(v-if="imItems.imType == 1 || imItems.imType == 2" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;") Nomor Dokumen SAP
                div(v-html="imItems.imNoDocument")
              div(v-if="imItems.imType < 6 || imItems.imType == 9 || imItems.imType == 11" style="text-align:justify;margin-top:15px;")
                h4(style="font-size:15px;")
                p Demikian permohonan ini kami buat, atas persetujuan Bapak/Ibu, kami ucapkan terima kasih.
              div(v-if="imItems.imType == 6" style="text-align:justify;margin-top:15px;")
                div(v-html="imItems.imUsulan" class="ck-content")
            //div(style="position:absolute;bottom:20px;right:35px;font-size:12px") {{ imItems.imNo }}
          .page(size="Auto" style="height:auto;")
            table(id="header-view" class="view-width print-header")
              tbody
                tr
                  td(v-if="imItems.imType != 9 && imItems.imType != 10" class="logo-cell") 
                    //- img(v-if="imItems.imGroup === 'gems'" src="../assets/smm-logo.png" class="width-300px")
                    //- img(v-if="imItems.imGroup === 'bcg'" src="../assets/bc-logo-188.png" class="width-300px")
                    //- img(v-if="imItems.imGroup == 'nongroup' && imItems.imCompany != 'Others' " :src="ngCompany" class="width-300px")
                    img(v-if="(imItems.imCompany != 'Others' && imItems.imCompany == 'Sun Energy Group')" :src="imgSrc" class="width-150px")
                    img(v-else-if="imItems.imCompany != 'Others' " :src="imgSrc" class="width-300px")
                  td(v-else class="logo-cell") 
                    img(v-if="imItems.imGroup === 'bc'" src="../assets/bc-logo-188.png" class="width-300px")
                    img(v-if="imItems.imGroup === 'bce'" src="../assets/bce-logo-188.png" class="width-300px")
                    img(v-if="imItems.imGroup === 'mtl'" src="../assets/mtl-logo-188.jpg" class="width-300px")
            p(style="font-size:14px;font-weight:bold;margin-bottom:-10px;") Approval list for IM No : {{imItems.imNo}}
            div(class="view-width detail-wrap" style="position:relative;font-size:14px;height:auto;")
              div(id="background")
                img(v-if="imItems.imStatus == 1" src="img/draft.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 2" src="img/on-approval.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 4" src="img/fully-approved.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 5" src="img/withdraw.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 8" src="img/rejected.png" class="imgWaterMark")
              table(class="view-width" border="1" style="margin:10px 0;border:1px solid black;border-collapse: collapse;text-align:center;z-index:100")
                tbody
                  tr(v-if="imItems.imType != 6 || imItems.imType == 9 || imItems.imType == 10 || imItems.imType == 11")
                    td(colspan="3" style="") 
                      b Diajukan oleh,
                  tr(v-if="imItems.imType != 6 || imItems.imType == 9 || imItems.imType == 10 || imItems.imType == 11")
                    td(v-if="imItems.imType == 11 && imItems.imUseAlias" width="36%") 
                      b Nama
                    td(v-else width="36%") 
                      b Nama/Jabatan
                    td(width="32%") 
                      b Komentar
                    td(width="32%")
                      b Tanda Tangan Digital
                  tr(v-if="imItems.imType != 6 || imItems.imType == 9 || imItems.imType == 10 || imItems.imType == 11")
                    td(v-if="imItems.imType == 11 && imItems.imUseAlias" width="40%" height="100px" class="px-3")
                      b {{ imItems.imUser.fullname }}
                    td(v-else width="40%" height="100px" class="px-3")
                      b {{ imItems.imUser.fullname }} / {{ imItems.imUser.title }}
                    td 
                      div(v-if="imItems.imStatus == 3 && imItems.imWorkflow[0].status == 6") Need reviewed
                    td 
                      div(v-if="imItems.imStatus == 5" class="approved")
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ 'User Withdraw'+ (getWithdrawDate ? ' at '+getTanggal(getWithdrawDate) : '') }}<br />
                      div(v-else-if="imItems.imStatus == 1" class="approved") &nbsp;
                      div(v-else class="approved")
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                      div(v-else-if="imItems.imStatus == 3" class="approved") {{ imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                  tr(v-for="(item, index) in imItems.imWorkflow" v-if="(item.postAs === 'requestor' && imItems.imType < 6) || (item.postAs === 'requestor' && imItems.imType == 9) || (item.postAs === 'requestor' && imItems.imType == 10) || (item.postAs === 'requestor' && imItems.imType == 11)" height="80px")
                    td(v-if="imItems.imType == 11 && imItems.imUseAlias" width="40%" class="px-3")
                      b(v-if="item.hasOwnProperty('aliasname') && item.aliasname") {{ item.aliasname }}
                      b(v-else-if="!item.hasOwnProperty('aliasname') && item.fullname") {{ item.fullname }}
                      b(v-else) {{ item.name ? item.name : item.fullname }}
                    td(v-else width="40%" class="px-3")
                      b(v-if="item.fullname") {{ item.fullname }} / {{ item.title }}
                      b(v-else) {{ item.name }} / {{ item.title }}
                    td(v-if="imItems.imStatus == 3")
                      div(v-if="imItems.imStatus == 3 && item.status == 3") Under Review
                      div(v-else-if="imItems.imStatus == 3 && item.id == imItems.imReturn[imItems.imReturn.length-1].id") 
                        | Reviewed by : {{ getReviewer(imItems).fullname ? getReviewer(imItems).fullname : getReviewer(imItems).name }}
                        br
                        | Comment : {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        br
                        | (Need Reapproval)
                      div(v-else-if="imItems.imStatus == 3 && item.date && (item.status == 6 || item.status == 9)") 
                        | {{ item.comment }}
                        br
                        | (Need Reapproval)
                      div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td(v-else-if="imItems.imStatus !=3 && imItems.hasOwnProperty('imReturn')")
                      div(v-if="imItems.imStatus == 2 && item.id == imItems.imReturn[imItems.imReturn.length-1].id && item.status != 7") 
                        | Returned to {{ getReviewer(imItems).fullname ? getReviewer(imItems).fullname : getReviewer(imItems).name }}
                        br
                        | Comment : {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        br
                        | (Need Reapproval)
                      div(v-if="imItems.imStatus == 8 && item.id == imItems.imReturn[imItems.imReturn.length-1].id && item.status != 7") 
                        | Returned to {{ getReviewer(imItems).fullname ? getReviewer(imItems).fullname : getReviewer(imItems).name }}
                        br
                        | Comment : {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                      div(v-else-if="imItems.imStatus == 2 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length-1].id") 
                        | {{ item.comment }}
                        br
                        | (Need Reapproval)
                      div(v-else-if="imItems.imStatus == 8 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length-1].id") 
                        | {{ item.comment }}
                        br
                      div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td(v-else)
                      div {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td
                      div(v-if="item.status == 7" class="approved") 
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else-if="imItems.imStatus == 3 && item.date" class="approved") {{ getTanggal(item.date) }}
                      div(v-else-if="item.status == 8" class="approved") 
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else-if="(imItems.imStatus == 2 || imItems.imStatus == 8) && imItems.hasOwnProperty('imReturn') && item.date" class="approved") {{ getTanggal(item.date) }}
                      div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />

                  tr(v-if="imItems.imType != 9")
                    td(colspan="3" align="center" style="") 
                      b Disetujui oleh,
                  tr(v-if="imItems.imType == 9")
                    td(colspan="3" align="center" style="") 
                      b Diketahui oleh,
                  tr(v-if="imItems.imType <= 6 || imItems.imType == 9 || imItems.imType == 10 || imItems.imType == 11")
                    td(v-if="imItems.imType == 11 && imItems.imUseAlias" width="36%") 
                      b Nama
                    td(v-else width="36%") 
                      b Nama/Jabatan
                    td(width="32%") 
                      b Komentar
                    td(width="32%")
                      b Tanda Tangan Digital
                  tr(v-for="(item, index) in imItems.imWorkflow" v-if="item.postAs !== 'requestor' && imItems.imType != 9  && item.status != 5" height="80px")
                    td(v-if="imItems.imType == 11 && imItems.imUseAlias" width="40%" class="px-3")
                      b(v-if="item.hasOwnProperty('aliasname') && item.aliasname") {{ item.aliasname }}
                      b(v-else-if="!item.hasOwnProperty('aliasname') && item.fullname") {{ item.fullname }}
                      b(v-else) {{ item.name ? item.name : item.fullname }}
                    td(v-else width="40%" class="px-3")
                      b(v-if="item.fullname") {{ item.fullname }} / {{ item.title }}
                      b(v-else) {{ item.name }} / {{ item.title }}
                    td(v-if="imItems.imStatus == 3")
                      div(v-if="imItems.imStatus == 3 && item.status == 3") Under Review
                      div(v-else-if="imItems.imStatus == 3 && item.id == imItems.imReturn[imItems.imReturn.length-1].id") 
                        | Reviewed by : {{ getReviewer(imItems).fullname ? getReviewer(imItems).fullname : getReviewer(imItems).name }}
                        br
                        | Comment : {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        br
                        | (Need Reapproval)
                      div(v-else-if="imItems.imStatus == 3 && item.date && (item.status == 6 || item.status == 9)") 
                        | {{ item.comment }}
                        br
                        | (Need Reapproval)
                      div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td(v-else-if="imItems.imStatus !=3 && imItems.hasOwnProperty('imReturn')")
                      div(v-if="imItems.imStatus == 2 && item.id == imItems.imReturn[imItems.imReturn.length-1].id && item.status != 7") 
                        | Returned to {{ getReviewer(imItems).fullname ? getReviewer(imItems).fullname : getReviewer(imItems).name }}
                        br
                        | Comment : {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        br
                        | (Need Reapproval)
                      div(v-if="imItems.imStatus == 8 && item.id == imItems.imReturn[imItems.imReturn.length-1].id && item.status != 7") 
                        | Returned to {{ getReviewer(imItems).fullname ? getReviewer(imItems).fullname : getReviewer(imItems).name }}
                        br
                        | Comment : {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                      div(v-else-if="imItems.imStatus == 2 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length-1].id") 
                        | {{ item.comment }}
                        br
                        | (Need Reapproval)
                      div(v-else-if="imItems.imStatus == 8 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length-1].id") 
                        | {{ item.comment }}
                        br
                      div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td(v-else)
                      div {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td
                      div(v-if="item.status == 7" class="approved") 
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else-if="imItems.imStatus == 3 && item.date" class="approved") {{ getTanggal(item.date) }}
                      div(v-else-if="item.status == 8" class="approved") 
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else-if="(imItems.imStatus == 2 || imItems.imStatus == 8) && imItems.hasOwnProperty('imReturn') && item.date" class="approved") {{ getTanggal(item.date) }}
                      div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />

                  tr(v-for="(item, index) in treasuryApprovers" v-if="item.postAs !== 'requestor' && imItems.imType == 9" height="80px")
                    td(width="40%" class="px-3")
                      b(v-if="item.fullname") {{ item.fullname }} / {{ item.title }}
                      b(v-else) {{ item.name }} / {{ item.title }}
                    td 
                      div(v-if="imItems.imStatus == 3 && item.status == 3") Need reviewed
                      div(v-else-if="imItems.imStatus == 3 && item.id == imItems.imReturn[imItems.imReturn.length-1].id") 
                        | Reviewed by : {{ getReviewer(imItems).fullname ? getReviewer(imItems).fullname : getReviewer(imItems).name }}
                        br
                        | Comment : {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                      div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td
                      div(v-if="item.status == 7" class="approved") 
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else-if="imItems.imStatus == 3 && item.id == imItems.imReturn[imItems.imReturn.length-1].id" class="approved") {{ getTanggal(item.date) }}
                      div(v-else-if="item.status == 8" class="approved") 
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />
                  tr(v-if="imItems.imType == 9")
                    td(colspan="3" align="center" style="") 
                      b Disetujui oleh,
                  tr(v-if="imItems.imType == 9")
                    td(v-if="imItems.imType == 11 && imItems.imUseAlias" width="36%") 
                      b Nama
                    td(v-else width="36%") 
                      b Nama/Jabatan
                    td(width="32%") 
                      b Komentar
                    td(width="32%")
                      b Tanda Tangan Digital
                  tr(v-for="(item, index) in validators" v-if="imItems.imType == 9" height="80px")
                    td(width="40%" class="px-3")
                      b(v-if="item.fullname") {{ item.fullname }} / {{ item.title }}
                      b(v-else) {{ item.name }} / {{ item.title }}
                    td(v-if="imItems.imStatus == 3")
                      div(v-if="imItems.imStatus == 3 && item.status == 3") Under Review
                      div(v-else-if="imItems.imStatus == 3 && item.id == imItems.imReturn[imItems.imReturn.length-1].id") 
                        | Reviewed by : {{ getReviewer(imItems).fullname ? getReviewer(imItems).fullname : getReviewer(imItems).name }}
                        br
                        | Comment : {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        br
                        | (Need Reapproval)
                      div(v-else-if="imItems.imStatus == 3 && item.date && (item.status == 6 || item.status == 9)") 
                        | {{ item.comment }}
                        br
                        | (Need Reapproval)
                      div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td(v-else-if="imItems.imStatus !=3 && imItems.hasOwnProperty('imReturn')")
                      div(v-if="imItems.imStatus == 2 && item.id == imItems.imReturn[imItems.imReturn.length-1].id && item.status != 7") 
                        | Returned to {{ getReviewer(imItems).fullname ? getReviewer(imItems).fullname : getReviewer(imItems).name }}
                        br
                        | Comment : {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        br
                        | (Need Reapproval)
                      div(v-if="imItems.imStatus == 8 && item.id == imItems.imReturn[imItems.imReturn.length-1].id && item.status != 7") 
                        | Returned to {{ getReviewer(imItems).fullname ? getReviewer(imItems).fullname : getReviewer(imItems).name }}
                        br
                        | Comment : {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                      div(v-else-if="imItems.imStatus == 2 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length-1].id") 
                        | {{ item.comment }}
                        br
                        | (Need Reapproval)
                      div(v-else-if="imItems.imStatus == 8 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length-1].id") 
                        | {{ item.comment }}
                        br
                      div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td(v-else)
                      div {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td
                      div(v-if="item.status == 7" class="approved") 
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else-if="imItems.imStatus == 3 && item.date" class="approved") {{ getTanggal(item.date) }}
                      div(v-else-if="item.status == 8" class="approved") 
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                        //- | Leadtime : {{ countLeadtime(item.date, imItems.imDate) }} hari
                      div(v-else-if="(imItems.imStatus == 2 || imItems.imStatus == 8) && imItems.hasOwnProperty('imReturn') && item.date" class="approved") {{ getTanggal(item.date) }}
                      div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />
              span(style="font-size:14px;font-weight:bold;color:red;") Scan QR code untuk memvalidasi kebenaran informasi atas tanda tangan digital di dokumen ini.
              p
                img(:src="qrImage" style="vertical-align:middle;width:150px;")
</template>

<script>
import axios from 'axios';
import { mapState } from "vuex";
import * as i18n from "../data/i18n.json";
export default {
  name: "IMViewEmail",
  props: {
    dialogType: String,
    imItems: Object,
    // userDetail: Object,
    activeStatus: Number,
    viewer: Object
  },
  data: () => ({
    i18n: i18n.default,
    approvalBtn: false,
    forwardDialog: false,
    forwardDialog2: false,
    approvalDialog: false,
    approvalDialog2: false,
    replyDialog: false,
    replyDialog2: false,
    comment: null,
    approval:null,
    users: [],
    select: {},
    forwardNote: null,
    replyNote: null,
    userForward: {},
    tembusan: [],
    qrImage: `/img/icons/loading.gif`,
    imgSrc:''
  }),
  computed: {
    ...mapState(["API_URL", "WE_URL"]),
    // ngCompany: function(){
    //   let result = '';
    //   for(const item of this.dataCompanies) {
    //     if (item.name == this.imItems.imCompany) {
    //       result = item.path;
    //       break;
    //     }
    //   }
    //   return result;
    // },
    reviewer: function() {
      let result = [];
      result.push(this.imItems.imUser);
      for (const wf of this.imItems.imWorkflow) {
        if(typeof wf.fullname === 'undefined'){
          this.$set(wf, 'fullname', wf.name);
        }
        if (wf.status == 9 || wf.status == 3)  break;
        result.push(wf);
      }
      return result;
    },
    jabatan: function() {
      if(this.select === this.imItems.imUser){
        return this.select.title + ' (Initiator)';
      }
      return this.select.title;
    },
    titleUser: function() {
      return this.userForward.title;
    },
    treasuryApprovers: function() {
      return this.imItems.imWorkflow.slice(0, this.imItems.imWorkflow.length-2)
    },
    validators: function() {
      return this.imItems.imWorkflow.slice(this.imItems.imWorkflow.length-2)
    }
    /*userApproval:function() {
      let workflow = [];
      let imWF = this.imItems.imWorkflow;
      let spvFlag = 1;
      var itSiteReject = false;
      var itSiteRejectDate = '';
      for (let l = 0; l < imWF.length; l++) {
        if (imWF[l].status != 5 && imWF[l].status != 10) {
          if (imWF[l].userType == 4) {
            if (!imWF[l+1]) {
              if (itSiteReject) {
                imWF[l].status = 8;
                imWF[l].itSiteReject = true;
                imWF[l].itSiteRejectDate = itSiteRejectDate;
              }
              workflow.push(imWF[l]);
            }
          } else {
            if (imWF[l].userType == 2 && spvFlag < 2) {
              workflow.push(imWF[l]);
              spvFlag++;
            }
            if (imWF[l].userType == 3 && imWF[l].status == 8) {
              itSiteReject = true;
              itSiteRejectDate = imWF[l].date;
            }
          }
        }
        if (imWF[l].status == 5) this.imItems.withdrawDate = imWF[l].date;
      }
      //if (this.userDetail.group === 'gems') {
        workflow.push(
          {
            status: 11,
            fullname: "..........................", 
            title: "In Charge", 
            userType: 5
          }
        );
      //}
      return workflow;
    }*/
  },
  mounted: async function() {
    this.approval = this.imItems.imStatus == 3 ? '3' : '7';
    
    let userDatas = await this.getUsers();
    for (const item of userDatas.data) {
      this.users.push(item);
    }

    if(this.imItems.imCC){
      for(const item of this.imItems.imCC){
        this.tembusan.push(item.nik);
      }
    }
    this.imgSrc = await this.getImgSrc();

    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      this.qrImage = `${this.API_URL}/qr/generate/${this.imItems.imNo}/${this.imItems.imType}`;
    });
  },
  methods: {
    getImgSrc: async function(){
      if (this.imItems.hasOwnProperty('imCompany') && this.imItems.imCompany != '' && this.imItems.imCompany != null && this.imItems.imCompany != ' ') {
        const config = {
          method: "get",
          url: `${this.API_URL}/api/companies?by=${JSON.stringify({"name":this.imItems.imCompany})}`,
          auth: {
            username: 'imemo',
            password: 'Ang3lT3n4n!#'
          }
        };
        const dataComp = await axios(config);
        return dataComp.data[0].path;  
      } else {
        return (this.imItems.imGroup === 'bcg') ? '../assets/bc-logo-188.png' : '../assets/smm-logo.png';
      }
    },
    getUsers: async function() {
      const config = {
        method: "get",
        url: `${this.WE_URL}/api/user`,
        auth: {
          username: 'imemo',
          password: 'Ang3lT3n4n!#'
        },
      };
      const dataUser = await axios(config);
      return dataUser;
    },
    routeName(val){
      if([1,2,3,4].includes(val)){
        return 'Edit IM Budget';
      }else if(val == 5){
        return 'Edit IM General';
      }else if(val == 6){
        return 'Edit IM Announcement';
      }else if(val == 7){
        return 'Edit Document Legal F1';
      }else if(val == 8){
        return 'Edit Document Legal F2';
      }else if(val == 9){
        return 'Edit IM Treasury';
      }else if(val == 10){
        return 'Edit IM Forex';
      }
    },
    getEditUrl(imType, imId) {
      if([1,2,3,4].includes(imType)){
        return 'im-budget/edit/' + imId;
      }else if(imType == 5){
        return 'im-non-budget/edit/' + imId;
      }else if(imType == 6){
        return 'im-announcement/edit/' + imId;
      }else if(imType == 7){
        return 'doc-legal-f1/edit/' + imId;
      }else if(imType == 8){
        return 'doc-legal-f2/edit/' + imId;
      }else if(imType == 9){
        return 'im-treasury/edit/' + imId;
      }else if(imType == 10){
        return 'im-forex/edit/' + imId;
      }
    },
    printIM: function(id) {
      printJS({
        printable: id, 
        type: 'html',
        targetStyles: ['*']
      });
    },
    getTanggal: function(tgl) {
      let monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
      let tanggal = new Date(tgl);
      let month = tanggal.getMonth();
      let date = tanggal.getDate() < 10 ? '0'+tanggal.getDate() : tanggal.getDate();
      return date+' '+monthNames[month]+' '+tanggal.getFullYear();
    },
    countLeadtime: function(d1, d2) {
      const tgl1 = new Date(d1);
      const tgl2 = new Date(d2);
      const date1 = new Date(tgl1.getFullYear()+'-'+(tgl1.getMonth()+1)+'-'+tgl1.getDate());
      const date2 = new Date(tgl2.getFullYear()+'-'+(tgl2.getMonth()+1)+'-'+tgl2.getDate());
      const timeDiff = Math.abs(date2.getTime() - date1.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return diffDays;
    },
    getFormatCurrency: function(imValue){
        const localization = imValue.currency == 'IDR' ? 'id-ID': 'en-US';
        const formatter = new Intl.NumberFormat(localization, {
          style: 'currency',
          currency: imValue.currency,
          minimumFractionDigits: 0
        })
        return formatter.format(imValue.value);
    },
    getReviewer(im) {
      let approver = false;
      for (var i = im.imWorkflow.length - 1; i >= 0; i--) {
        if (im.imWorkflow[i].status == 3) return im.imWorkflow[i];
      }
      if (!approver && i == -1) return im.imUser;
    },
    download(files) {
      if (Array.isArray(files)) {
        for (const key in files) {
          window.open(`${this.API_URL}/fileupload/${files[key]}`, '_blank');
        }
      } else {
        window.open(`${this.API_URL}/fileupload/${files}`, '_blank');
      }
    }
  },
  watch: {
    approvalDialog2 (val) {
      if (!val) return
      if(this.$route.name == `Approval Forex Landing Page`){
        const config = {
          method: "put",
          url: `${this.API_URL}/forex/update/requests`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, status: parseInt(this.approval), comment: this.comment, backto: parseInt(this.approval) == 3 ? this.select : null}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }else{
        const config = {
          method: "put",
          url: `${this.API_URL}/api/update/requests`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, status: parseInt(this.approval), comment: this.comment, backto: parseInt(this.approval) == 3 ? this.select : null}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }
    },
    forwardDialog2 (val) {
      if (!val) return
      if(this.$route.name == `Approval Forex Landing Page`){
        const config = {
          method: "post",
          url: `${this.API_URL}/forex/requests/forward`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, userId: this.userForward.nik, note: this.forwardNote, by: this.viewer._id, reply: 0}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }else{
        const config = {
          method: "post",
          url: `${this.API_URL}/api/requests/forward`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, userId: this.userForward.nik, note: this.forwardNote, by: this.viewer._id, reply: 0}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }
    },
    replyDialog2 (val){
      if(!val) return
      if(this.$route.name == `Approval Forex Landing Page`){
        const config = {
          method: "post",
          url: `${this.API_URL}/forex/requests/forward`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, userId: this.viewer.sender, note: this.replyNote, by: this.viewer._id, reply: 1}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }else{
        const config = {
          method: "post",
          url: `${this.API_URL}/api/requests/forward`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, userId: this.viewer.sender, note: this.replyNote, by: this.viewer._id, reply: 1}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.print-bg {
  background: rgb(204,204,204) !important;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:3px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  font-size: 11px;
  padding: 15px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.width-150px {
  width: 150px;
}
.top-align {
  vertical-align:top;
}

/* The containerLbl */
.containerLbl {
  position: relative;
  padding-left: 20px;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerLbl input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.containerLbl:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.containerLbl input:checked ~ .checkmark {
  background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerLbl input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerLbl .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    .pagebreak { page-break-after: always; } /* page-break-after works, as well */
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:0px;
  left:0px;
  text-align: right;
  width: 100%;
}
.imgWaterMark {
  width: 201px;
  position:absolute;
  top:0px;
  right:35px;
}
</style>